import React from "react";
import {Route, Switch, Redirect, withRouter} from "react-router-dom";
import Home from "./containers/Home";
import NotFound from "./containers/NotFound";
import Login from "./containers/login/Login";

import AuthenticatedRoute from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";

// import Settings from "./containers/Settings.js";
import Add from "./containers/add/AddNew";
import AddManagers from "./containers/add/AddManager"
import ChangePassword from "./containers/login/ChangePassword";
import UpdateDetails from "./containers/login/UpdateDetails"
import Tasks from "./containers/Tasks"
import NewForm from "./containers/form/FormContainer"
import Applicants from "./containers/applicants/Applicants"
import Offer from "./containers/offer/Offer"
import Myob from "./containers/exports/Myob"
import ChristmasCasuals from "./containers/christmas/ChristmasCasuals"
import PrivacyPolicy from "./containers/policy/PrivacyPolicy"
import withAuth from "./components/WithAuth"
import AdminPanel from "./containers/admin/AdminPanel";
import Feed from "./containers/feed/Feed"
import ShippingNew from "./containers/shipping/ShippingTestNew";
import Shipping from "./containers/shipping/ShippingTest";
import Orders from "./containers/stores/StoreOrderView";
import Collect from "./containers/shipping/CollectVerification"
import CollectNew from "./containers/shipping/CollectVerificationNew"
import Reporting from "./containers/reporting/Reporting";
import ReportingNew from "./containers/reporting/ReportingNew";
import ShippingReport from "./containers/reporting/shipping/shippingReport";
import ShippingReportNew from "./containers/reporting/shipping/shippingReportNew";
import ShippingTablePrototype from './containers/shipping/ShippingTablePrototype';

import TestPrinter from "./containers/TestPrinter"
import { connect } from "react-redux";

// NewStore pilot stores - S2D page hidden for these stores
export const newStorePilotStores = [
    '365',
    '669',
    '229',
    '206',
    '227',
    '320',
    '219',
    '303',
    '307',
    '308',
    '309',
    '310',
    '313',
    '315',
    '317',
    '332',
    '334',
    '335',
    '657',
    '301',
    '302',
    '304',
    '305',
    '312',
    '314',
    '316',
    '318',
    '319',
    '331',
    '333',
    '656',
    '419',
    '422',
    '640',
    '664',
    '662',
    '663',
    '665',
    '222',
    '401',
    '404',
    '405',
    '407',
    '411',
    '413',
    '414',
    '641',
    '642',
    '643',
    '644',
    '645',
    '406',
    '501',
    '403',
    '423',
    '417',
    '418',
    '420',
    '421',
    '490',
    '412',
    '410',
    '416',
    '409',
    '228',
    '362',
    '659',
    '311',
    '367',
    '363',
    '364',
    '202',
    '224',
    '220',
    '204',
    '207',
    '653',
    '212',
    '660',
    '361',
    '652',
    '208',
    '646',
    '368',
    '661',
    '225',
    '211',
    '203',
    '654',
    '366',
    '658',
    '209',
    '647',
    '372',
    '221',
    '205',
    '223',
    '650',
    '369',
    '649',
    '370',
    '226',
    '651',
    '373',
    '648',
    '374',
    '218',
    '210',
    '216',
    '215',
    '252',
    '655',
    '213',
    '214',
    '251',
    '217',
    '371',
    '375'
];

// New feature flag stores
const newFeatureStores = [
    // Perfect Stranger
    '640',
    '641',
    '642',
    '643',
    '644',
    '645',
    '646',
    '647',
    '649',
    '650',
    '652',
    '654',
    '655',
    '648',
    '651',
    '656',
    '657',
    // Universal Store
    '331',
    '332',
    '333',
    '334',
    '202',
    '204',
    '208',
    '211',
    '215',
    '217',
    '225',
    '407',
    '414',
    '417',
    '418',
    '419',
    '422',
    '222',
    '405',
    '406',
    '413',
    '421',
    '490',
    '203',
    '205',
    '209',
    '218',
    '221',
    '224',
    '401',
    '403',
    '404',
    '409',
    '410',
    '411',
    '416',
    '420',
    '423',
    '206',
    '210',
    '213',
    '220',
    '223',
    '207',
    '212',
    '214',
    '216',
    '251',
    '252',
    '219',
    '301',
    '302',
    '303',
    '304',
    '305',
    '307',
    '308',
    '309',
    '310',
    '311',
    '312',
    '313',
    '314',
    '315',
    '316',
    '317',
    '318',
    '319',
    '361',
    '362',
    '363',
    '364',
    '365',
    '366',
    '367',
    '368',
    '369',
    '370',
    '371',
    '372',
    '373',
    '412'
];

// Store-specific report URLs
const storeReportUrls = {
    // Perfect Stranger
    '640': 'https://lookerstudio.google.com/embed/reporting/27818160-1d47-40bf-9070-d1e685d9a1ae/page/p_uykwhmrtrd',
    '641': 'https://lookerstudio.google.com/embed/reporting/756fa503-5809-46ad-a5e3-9eacbd2a417f/page/p_uykwhmrtrd',
    '642': 'https://lookerstudio.google.com/embed/reporting/554e0825-1670-429d-8932-49c83a0c4906/page/p_uykwhmrtrd',
    '643': 'https://lookerstudio.google.com/embed/reporting/dea195ab-0c1c-415e-a83c-b66121b0043f/page/p_uykwhmrtrd',
    '644': 'https://lookerstudio.google.com/embed/reporting/8f623298-3aa5-49a3-9d3a-7b7dccb6b1a9/page/p_uykwhmrtrd',
    '645': 'https://lookerstudio.google.com/embed/reporting/bcbba06b-8407-4c72-8401-acf417a6acec/page/p_uykwhmrtrd',
    '646': 'https://lookerstudio.google.com/embed/reporting/c8bbbb05-a62e-426d-8840-aac7f8bdcc5d/page/p_uykwhmrtrd',
    '647': 'https://lookerstudio.google.com/embed/reporting/a2fda708-337f-44ad-87d4-b3cb7aa91213/page/p_uykwhmrtrd',
    '649': 'https://lookerstudio.google.com/embed/reporting/bfb741c7-c9e1-40e3-b875-0489cf24a7cb/page/p_uykwhmrtrd',
    '650': 'https://lookerstudio.google.com/embed/reporting/413baef0-02b6-4ae1-82a5-686630471d09/page/p_uykwhmrtrd',
    '652': 'https://lookerstudio.google.com/embed/reporting/a16e8298-7935-48ba-8c52-429e9fb68715/page/p_uykwhmrtrd',
    '654': 'https://lookerstudio.google.com/embed/reporting/5d46d342-0388-4ce7-8591-50988c5730b4/page/p_uykwhmrtrd',
    '655': 'https://lookerstudio.google.com/embed/reporting/266a0d25-f4a5-44a3-8804-649a8a40c8b8/page/p_uykwhmrtrd',
    '648': 'https://lookerstudio.google.com/embed/reporting/2dc757ca-aebf-442b-8eb5-48fa6220af75/page/p_uykwhmrtrd',
    '651': 'https://lookerstudio.google.com/embed/reporting/744fb31b-5a6b-42d9-86fc-0aba73b4108d/page/p_uykwhmrtrd',
    '656': 'https://lookerstudio.google.com/embed/reporting/f1495e35-0467-477f-9e35-ab5a194db8ce/page/p_uykwhmrtrd',
    '657': 'https://lookerstudio.google.com/embed/reporting/977ed3de-a772-4741-94ed-b47ca140e71e/page/p_uykwhmrtrd',
    // Universal Store
    '331': 'https://lookerstudio.google.com/embed/reporting/7b63942e-609e-4a29-a160-d92b5c34dcdf/page/p_uykwhmrtrd', // SA
    '332': 'https://lookerstudio.google.com/embed/reporting/c4fced6f-92ff-41e7-b2e0-bad07b0fe172/page/p_uykwhmrtrd', // SA
    '333': 'https://lookerstudio.google.com/embed/reporting/dd45972c-4e8d-4fa8-9c79-142b13ac3b86/page/p_uykwhmrtrd', // SA
    '334': 'https://lookerstudio.google.com/embed/reporting/1edce2e0-9903-477b-a5fe-5f5ffd09adc6/page/p_uykwhmrtrd', // SA
    '202': 'https://lookerstudio.google.com/embed/reporting/a646a8fb-e06c-4d19-9541-083b8970214d/page/p_uykwhmrtrd',
    '204': 'https://lookerstudio.google.com/embed/reporting/95ba2fa2-b0bc-4f2e-aae5-d50083864492/page/p_uykwhmrtrd',
    '208': 'https://lookerstudio.google.com/embed/reporting/3c2fa369-7d97-4a8f-a14c-1ed8cc50cd42/page/p_uykwhmrtrd',
    '211': 'https://lookerstudio.google.com/embed/reporting/d7f54722-2882-4919-9dfd-02bbf2e8b117/page/p_uykwhmrtrd',
    '215': 'https://lookerstudio.google.com/embed/reporting/c44ec8a3-5d9d-4095-b036-775c81d0d7a3/page/p_uykwhmrtrd',
    '217': 'https://lookerstudio.google.com/embed/reporting/e1365ef5-234f-4072-a7b0-319d1e5a6db2/page/p_uykwhmrtrd',
    '225': 'https://lookerstudio.google.com/embed/reporting/59c564db-5758-4a9e-85f5-253587ba18f0/page/p_uykwhmrtrd',
    '407': 'https://lookerstudio.google.com/embed/reporting/cff3b3a1-2dfe-4656-afa9-e42336e91f81/page/p_uykwhmrtrd',
    '414': 'https://lookerstudio.google.com/embed/reporting/ec903eca-52f7-4197-94d1-5581a805f388/page/p_uykwhmrtrd',
    '417': 'https://lookerstudio.google.com/embed/reporting/16951378-c3c0-4438-a3df-f491959c7811/page/p_uykwhmrtrd',
    '418': 'https://lookerstudio.google.com/embed/reporting/a186b9be-23b9-44b9-8802-d774de40218b/page/p_uykwhmrtrd',
    '419': 'https://lookerstudio.google.com/embed/reporting/4870f37f-9285-41af-b360-940778e1238a/page/p_uykwhmrtrd',
    '422': 'https://lookerstudio.google.com/embed/reporting/ae089ea6-d89a-4686-96a1-27b589ad5495/page/p_uykwhmrtrd',
    '222': 'https://lookerstudio.google.com/embed/reporting/b00da96d-7a53-4838-85b1-72aedc5f6487/page/p_uykwhmrtrd',
    '405': 'https://lookerstudio.google.com/embed/reporting/967e6838-7de6-4815-98e5-73ab342c6bf1/page/p_uykwhmrtrd',
    '406': 'https://lookerstudio.google.com/embed/reporting/02cf8948-4d41-469c-9bf5-f37fe7b79749/page/p_uykwhmrtrd',
    '413': 'https://lookerstudio.google.com/embed/reporting/aa99573f-e1cb-4807-92c7-d13d7e363c51/page/p_uykwhmrtrd',
    '421': 'https://lookerstudio.google.com/embed/reporting/33f9bdd9-b6f2-40fc-9088-aecc38a62015/page/p_uykwhmrtrd',
    '490': 'https://lookerstudio.google.com/embed/reporting/042cfc9a-b3a2-42fe-b387-7fd9783b80d6/page/p_uykwhmrtrd',
    '203': 'https://lookerstudio.google.com/embed/reporting/0e218c44-4a8b-4faf-9d05-011e5e665658/page/p_uykwhmrtrd',
    '205': 'https://lookerstudio.google.com/embed/reporting/9dade667-45e3-4fb4-8dcc-04ce7cbf584d/page/p_uykwhmrtrd',
    '209': 'https://lookerstudio.google.com/embed/reporting/9352f437-a987-46cc-b5a9-e5cf0e9a1f02/page/p_uykwhmrtrd',
    '218': 'https://lookerstudio.google.com/embed/reporting/f9211bdf-0b79-4f52-87a0-9057e4638168/page/p_uykwhmrtrd',
    '221': 'https://lookerstudio.google.com/embed/reporting/aa49dc69-c79b-4e1b-95de-5f774419aab9/page/p_uykwhmrtrd',
    '224': 'https://lookerstudio.google.com/embed/reporting/d9175ac2-b813-4506-b79a-6113fb74e3ee/page/p_uykwhmrtrd',
    '401': 'https://lookerstudio.google.com/embed/reporting/b51d9d3a-3c7c-48c1-b5e5-156bb5260a91/page/p_uykwhmrtrd',
    '403': 'https://lookerstudio.google.com/embed/reporting/ac6539af-167c-41d2-8f4b-38daa27e1104/page/p_uykwhmrtrd',
    '404': 'https://lookerstudio.google.com/embed/reporting/fd9df01c-2b4d-4a5b-b5c5-7f1ee8aaa330/page/p_uykwhmrtrd',
    '409': 'https://lookerstudio.google.com/embed/reporting/1e7dc7ee-2765-47ab-87df-abc1ba8a61c0/page/p_uykwhmrtrd',
    '410': 'https://lookerstudio.google.com/embed/reporting/7d2f434b-b091-47b7-9a77-54d97388f33b/page/p_uykwhmrtrd',
    '411': 'https://lookerstudio.google.com/embed/reporting/9107db88-7e69-4596-b296-76e008e6324e/page/p_uykwhmrtrd',
    '416': 'https://lookerstudio.google.com/embed/reporting/470b7b0b-89ee-4723-bcc7-d76d6db0d0d1/page/p_uykwhmrtrd',
    '420': 'https://lookerstudio.google.com/embed/reporting/9595a9bb-e933-4e08-9294-e98fb90162f5/page/p_uykwhmrtrd',
    '423': 'https://lookerstudio.google.com/embed/reporting/89182f2a-b4b0-4bcb-a2a5-bf4d54dad6b9/page/p_uykwhmrtrd',
    '206': 'https://lookerstudio.google.com/embed/reporting/aeb82a0e-a417-424a-a0de-9a6839d81029/page/p_uykwhmrtrd',
    '210': 'https://lookerstudio.google.com/embed/reporting/e874dee9-c15f-4abf-a89a-4c3ca79b6abc/page/p_uykwhmrtrd',
    '213': 'https://lookerstudio.google.com/embed/reporting/92eb0bae-24c8-4fc7-869f-c99a1b05190f/page/p_uykwhmrtrd',
    '220': 'https://lookerstudio.google.com/embed/reporting/e17b2ae6-6805-4526-a3f1-697f71ee324c/page/p_uykwhmrtrd',
    '223': 'https://lookerstudio.google.com/embed/reporting/225f6f5a-793c-473d-98ab-7bc9e4848fac/page/p_uykwhmrtrd',
    '207': 'https://lookerstudio.google.com/embed/reporting/a7e142f3-af4a-4c3d-ab71-a329bde4063f/page/p_uykwhmrtrd',
    '212': 'https://lookerstudio.google.com/embed/reporting/fee46bc9-af3e-491a-9307-23574af34088/page/p_uykwhmrtrd',
    '214': 'https://lookerstudio.google.com/embed/reporting/83259351-d7b6-4bf5-a648-0dc46123120b/page/p_uykwhmrtrd',
    '216': 'https://lookerstudio.google.com/embed/reporting/90760f7b-d024-4b14-a2c9-b306d860998a/page/p_uykwhmrtrd',
    '251': 'https://lookerstudio.google.com/embed/reporting/011900ac-23c2-48d2-b449-a3be30bcb24d/page/p_uykwhmrtrd',
    '252': 'https://lookerstudio.google.com/embed/reporting/47e41dac-b5fe-4efc-85c3-e3e6bc0bff8e/page/p_uykwhmrtrd',

    '301': 'https://lookerstudio.google.com/embed/reporting/fba9220c-30ac-4a7d-b735-5ba5bfaddcfa/page/p_uykwhmrtrd',
    '302': 'https://lookerstudio.google.com/embed/reporting/1c51e334-1d1c-460b-a87b-9179f1f60acc/page/p_uykwhmrtrd',
    '304': 'https://lookerstudio.google.com/embed/reporting/62e83550-5e74-42b3-be56-56740d82b863/page/p_uykwhmrtrd',
    '308': 'https://lookerstudio.google.com/embed/reporting/4ae65374-51eb-49b1-a7cf-224dcc7a7f16/page/p_uykwhmrtrd',
    '309': 'https://lookerstudio.google.com/embed/reporting/08ad7ab3-33be-4503-bfb2-654089d304ad/page/p_uykwhmrtrd',
    '312': 'https://lookerstudio.google.com/embed/reporting/26bfe596-a3e3-4dcb-9858-d0dffbfee763/page/p_uykwhmrtrd',
    '313': 'https://lookerstudio.google.com/embed/reporting/ac64365a-a0bf-47c6-a108-54b2440d365f/page/p_uykwhmrtrd',
    '316': 'https://lookerstudio.google.com/embed/reporting/b0f43dad-9567-45f1-a617-6ad95a6f23f4/page/p_uykwhmrtrd',
    '317': 'https://lookerstudio.google.com/embed/reporting/c792d6e7-2e78-4e52-b926-5f5c3966371e/page/p_uykwhmrtrd',
    '501': 'https://lookerstudio.google.com/embed/reporting/d103bc83-cdba-4f90-840a-75c6f6c43a05/page/p_uykwhmrtrd',
    '219': 'https://lookerstudio.google.com/embed/reporting/28d5fc04-eb61-447b-9a9f-5af08bb2d94a/page/p_uykwhmrtrd',
    '303': 'https://lookerstudio.google.com/embed/reporting/c43c755b-49b8-41df-ab2c-6f01257106dd/page/p_uykwhmrtrd',
    '305': 'https://lookerstudio.google.com/embed/reporting/601b9005-38c7-46d9-9860-f5c5bb2a65cc/page/p_uykwhmrtrd',
    '307': 'https://lookerstudio.google.com/embed/reporting/1a16daa6-c9d9-4827-9b10-38e0d2ffdd42/page/p_uykwhmrtrd',
    '310': 'https://lookerstudio.google.com/embed/reporting/7a65035e-b02f-44aa-ad50-357adc86c142/page/p_uykwhmrtrd',
    '311': 'https://lookerstudio.google.com/embed/reporting/54759fbf-172d-463d-9837-6daa41844d7a/page/p_uykwhmrtrd',
    '314': 'https://lookerstudio.google.com/embed/reporting/7b8c6b57-6367-41e6-bfca-2618979a9fc8/page/p_uykwhmrtrd',
    '315': 'https://lookerstudio.google.com/embed/reporting/a4532792-af47-460d-b7c2-aab81af54f6d/page/p_uykwhmrtrd',
    '318': 'https://lookerstudio.google.com/embed/reporting/1cb91b48-67dd-4671-ab1f-bf4e1fd92866/page/p_uykwhmrtrd',
    '319': 'https://lookerstudio.google.com/embed/reporting/53b8e528-bb4a-488b-a2ca-d169dcfbedc8/page/p_uykwhmrtrd',
    '362': 'https://lookerstudio.google.com/embed/reporting/a66be037-df14-413e-a436-70e2bbfa890e/page/p_uykwhmrtrd',
    '363': 'https://lookerstudio.google.com/embed/reporting/a766aff3-7cfe-48d3-9963-904d8d206e36/page/p_uykwhmrtrd',
    '365': 'https://lookerstudio.google.com/embed/reporting/d5113e7c-68ea-41f4-a6a7-1a3ac7a0e206/page/p_uykwhmrtrd',
    '367': 'https://lookerstudio.google.com/embed/reporting/cecae94f-f0b5-438a-9c6b-bab788776646/page/p_uykwhmrtrd',
    '370': 'https://lookerstudio.google.com/embed/reporting/98fe9689-48d4-407e-ae2a-b3992c5f5181/page/p_uykwhmrtrd',
    '371': 'https://lookerstudio.google.com/embed/reporting/ce10eb48-458e-4d65-8371-4981c57f472a/page/p_uykwhmrtrd',
    '372': 'https://lookerstudio.google.com/embed/reporting/e9afe5bd-7a28-48d1-8d08-af59e4c98d17/page/p_uykwhmrtrd',
    '361': 'https://lookerstudio.google.com/embed/reporting/104a07e2-ef79-4534-b9b4-86a03bbdf226/page/p_uykwhmrtrd',
    '364': 'https://lookerstudio.google.com/embed/reporting/d440b20b-279b-4e75-a644-09942455f32e/page/p_uykwhmrtrd',
    '366': 'https://lookerstudio.google.com/embed/reporting/76a8d807-16c1-41ca-9300-147be5d68250/page/p_uykwhmrtrd',
    '368': 'https://lookerstudio.google.com/embed/reporting/5268150b-9b48-4280-9cf4-c532fdd663e8/page/p_uykwhmrtrd',
    '369': 'https://lookerstudio.google.com/embed/reporting/dc148aca-7af8-425e-91b3-f60aa68ffb1f/page/p_uykwhmrtrd',
    '373': 'https://lookerstudio.google.com/embed/reporting/57aebc63-ab21-4695-96be-0567bc3e292d/page/p_uykwhmrtrd',
    '412': 'https://lookerstudio.google.com/embed/reporting/4d9955ee-26ca-4132-86c4-32e31ff07f1c/page/p_uykwhmrtrd',

    'default': ''
};

const createComponentSwitcher = (NewComponent, LegacyComponent) => {
    const ComponentWrapper = ({ user, ...otherProps }) => {
        const storeId = user?.store || '';

        // Get the store-specific report URL or default if not found
        const reportUrl = storeReportUrls[storeId] || storeReportUrls.default;

        // Always use the NewComponent
        const Component = NewComponent;
        return <Component reportUrl={reportUrl} {...otherProps} />;
    };

    return connect(
        state => ({ user: state.authState })
    )(ComponentWrapper);
};

const OrderGuard = connect(state => ({ store: state.authState.store }))(({ store, ...props }) => {
    if (newStorePilotStores.includes(store)) {
        return <Redirect to="/" />;
    }
    return <Orders {...props} />;
});

const ConnectedShippingWrapper = createComponentSwitcher(ShippingTablePrototype, Shipping);
const ConnectedCollectWrapper = createComponentSwitcher(CollectNew, Collect);
const ConnectedShippingReportWrapper = createComponentSwitcher(ShippingReportNew, ShippingReport);

/**
 * Routes take in a componenet that is wrapped in a HOC (withAuth), withAuth takes in three parameters (Component,state,allowedPermissions)
 * where state is state to be injected into the store.
 * Both state and allowedPermissions are optional
 * @param childProps
 * @returns {*}
 */
export default ({ childProps }) =>

    <Switch>

        <AuthenticatedRoute path="/" exact component={withAuth(Home)} props={childProps}/>

        <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />

        <Route path="/feed" exact component = {withAuth(Feed,"feedState")} />

        <Route path="/forgotten" exact component={ChangePassword} props={childProps} />

        <Route path="/update" exact component={withAuth(UpdateDetails)} />

        <Route path="/add" exact component={withAuth(Add,"storesState",["onboarding::add"])} />

        <Route path="/add/managers" exact component={withAuth(AddManagers,null,["onboarding::add::manager"])} />

        <Route path="/onboarding" exact component={withAuth(NewForm,"onboardingState")} />

        <Route path="/tasks" exact component = {withAuth(Tasks)} />

        <Route path="/ship" exact component={withAuth(ConnectedShippingWrapper, 'shippingState', ["shipping"], ['HR','STORE'])} />

        <Route path="/order" exact component = {withAuth(OrderGuard,['checkoutState','catalogState'],["shipping"], ['STORE'])} />

        <Route path="/printer" exact component = {withAuth(TestPrinter,null,["shipping"], ['STORE'])} />

        <Route path="/collect" exact component={withAuth(ConnectedCollectWrapper, 'shippingState', ["shipping"], ['HR','STORE'])} />

        <Route path = "/privacy" exact component={PrivacyPolicy} />

        <Route path="/reporting/shipping" exact component={withAuth(ConnectedShippingReportWrapper, 'reportingState', ["reporting::full", "reporting::store"])} />
        {/* <Route path="/reporting/shipping" exact component={withAuth(ConnectedShippingReportWrapper, 'reportingState', ["shipping"], ['HR','STORE'])} /> */}

        <Route path = "/christmas" exact component = {ChristmasCasuals} />

        <Route path="/applicants" exact component = {withAuth(Applicants,"applicantsState",["onboarding::applicants"])} />

        <Route path="/offer" exact component = {withAuth(Offer,null)} />

        <Route path="/admin" exact component={withAuth(AdminPanel,['adminState','storesState'],["admin"],['HR','SUPERUSER'])} />

        <Route path="/myob" exact component={withAuth(Myob,null,["view:myob"])} />

        <Route component={NotFound} />
    </Switch>

;




